"use client";

import { useRouter } from "next/navigation";
import { authClient } from "@/lib/auth-client";
import { NavLinkButton } from "./NavBar.styled";

export function SignOutButton() {
  const router = useRouter();

  const handleSignOut = async () => {
    await authClient.signOut();
    router.refresh();
  };

  return <NavLinkButton onClick={handleSignOut}>Sign out </NavLinkButton>;
}
